<template>
  <div class="dash-modal-backdrop dash-modal-top" @click.self="close">
    <div class="dash-modal lv-decision-modal" role="dialog" aria-label="Approve leave">
      <div class="dash-modal-header">
        <div style="min-width: 0;">
          <h6 class="dash-modal-title">Approve leave</h6>
          <p class="dash-modal-subtitle">The employee is emailed the decision and the days come off their balance.</p>
        </div>
        <button type="button" class="side-drawer-close" aria-label="Close" @click="close"><i class="pi pi-times"></i></button>
      </div>

      <div class="dash-modal-body">
        <leaveRequestSummary :request="selectedLeaveRequest" :leaveType="leaveType" afterApproval />
        <div v-if="goesNegative" class="pay-notice warn" style="margin: 12px 0 0 0;">
          <i class="pi pi-exclamation-triangle"></i>
          <div class="body">Approving this takes the balance below zero.</div>
        </div>
      </div>

      <div class="dash-modal-footer">
        <button type="button" class="btn btn-custom-secondary" :disabled="saving" @click="close">Cancel</button>
        <button type="button" class="btn btn-custom-primary" :disabled="saving" @click="approve">
          <span v-if="saving" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          <span v-else><i class="pi pi-check"></i> Approve</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import leaveRequestSummary from '@/components/leave_request/Leave_Request_Summary.vue';
import { APPROVE_LEAVE_REQUEST } from '@/store/action_types';
import { TOAST_GLOBAL_CONFIG } from '@/utils/const';
import { requestBalance } from '@/utils/leave';

export default {
  name: 'ApproveLeaveRequestModal',
  components: { leaveRequestSummary },
  props: {
    selectedLeaveRequest: { type: Object, required: true },
    leaveType: { type: Object, default: null },
  },
  emits: ['closeApproveLeaveRequestModal', 'refreshLeaveRequests'],
  computed: {
    saving() {
      return this.$store.getters.leaveRequest.isLoading;
    },
    goesNegative() {
      const balance = requestBalance(this.selectedLeaveRequest);
      const tracked = this.leaveType?.leavePolicy?.balanceTracked ?? this.selectedLeaveRequest.leaveType?.leavePolicy?.balanceTracked;
      if (!balance || tracked === false) return false;
      return Number(balance.available ?? 0) - Number(this.selectedLeaveRequest.days ?? 0) < 0 && tracked === true;
    },
  },
  methods: {
    close() {
      if (!this.saving) this.$emit('closeApproveLeaveRequestModal');
    },
    async approve() {
      const ok = await this.$store.dispatch(APPROVE_LEAVE_REQUEST, { id: this.selectedLeaveRequest.id });
      if (!ok) return;
      this.$toast.success('Leave approved', TOAST_GLOBAL_CONFIG);
      this.$emit('refreshLeaveRequests');
      this.$emit('closeApproveLeaveRequestModal');
    },
    onKey(event) {
      if (event.key === 'Escape') this.close();
    },
  },
  mounted() {
    document.addEventListener('keydown', this.onKey);
  },
  beforeUnmount() {
    document.removeEventListener('keydown', this.onKey);
  },
};
</script>
